/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { UnsupportedInline } from '@atlaskit/editor-common/ui';
export var UnsupportedInlineNodeView = function UnsupportedInlineNodeView(props) {
  return jsx(UnsupportedInline, props);
};